import React, { useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import {getMatrixJson, setLotNumber, setModel, setBlock, testAvailability} from '../../api/LotMatrix/lotMatrix.api';
//redux
import './LotMatrix.css'
import { Grid } from "@material-ui/core";
import { connect } from 'react-redux';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";


const LotMatrix = () => {

    const [entireMatrix, setEntireMatrix] = useState();
    var xMatrix =[];
    if(entireMatrix == undefined){
        getMatrixJson((_input)=>{
            console.log("RECEIVED CALL BACK " + _input)
            setEntireMatrix(_input);
        })
    }
    if(entireMatrix != undefined){
        xMatrix = Object.keys(entireMatrix);
        console.log("MATRIX KEYS " , xMatrix);
    }

    const thisYMatrix = (entrymatrix, xindex) =>{
        var yMat = [];

        if(entrymatrix != undefined)
        {
            yMat = Object.keys(entrymatrix[xindex]);

            return(<>
                {yMat.map((yIndex)=>(
                    <>{yMatrixColor(entrymatrix, xindex, yIndex)}</>
                ))}
            </>);
        }
        else{
            return(<>
                {yMat.map((yIndex)=>(
                    <>{yMatrixColor(entrymatrix, xindex, yIndex)}</>
                ))}
            </>);
        }

    }

    const yMatrixColor = (entrymatrix, xindex, yIndex) =>{

        var idLotNumber = "lotNumberx" + xindex + "y" + yIndex;
        var modelNumber = "modelNumberx" + xindex + "y" + yIndex;
        var blockNumber = "blockNumber" + xindex + "y" + yIndex;
        
        if(entrymatrix[xindex][yIndex].model == "none" && entrymatrix[xindex][yIndex].lotNumber == "0"){
            return(
                <div className="gridBox">
                    <ul>
                        <li>x index = {xindex} </li>
                        <li>y index = {yIndex} </li>
                        <li>lotNumber = { entrymatrix[xindex][yIndex].lotNumber}</li>
                        <li>model = { entrymatrix[xindex][yIndex].model}</li>
                        <li>blockNumber = { entrymatrix[xindex][yIndex].blockNumber}</li>
                        <li>elevation = { entrymatrix[xindex][yIndex].elevation}</li>
                    </ul>
                    <input type="text" id={idLotNumber}></input>
                    <input type="text" id={modelNumber}></input>
                    <input type="text" id={blockNumber}></input>
                    <button onClick={()=>{setLotAndModel(xindex, yIndex);}}>Enter</button>
                    <button onClick={()=>{setBlockNumber(xindex, yIndex);}}>Block</button>
                </div>
            );
        }
        else if(entrymatrix[xindex][yIndex].lotNumber != "0"){
            return(
                <div className="gridBoxColor3">
                    <ul>
                        <li>x index = {xindex} </li>
                        <li>y index = {yIndex} </li>
                        <li>lotNumber = { entrymatrix[xindex][yIndex].lotNumber}</li>
                        <li>model = { entrymatrix[xindex][yIndex].model}</li>
                        <li>blockNumber = { entrymatrix[xindex][yIndex].blockNumber}</li>
                        <li>elevation = { entrymatrix[xindex][yIndex].elevation}</li>
                    </ul>
                    <input type="text" id={idLotNumber}></input>
                    <input type="text" id={modelNumber}></input>
                    <input type="text" id={blockNumber}></input>
                    <button onClick={()=>{setLotAndModel(xindex, yIndex);}}>Enter</button>
                    <button onClick={()=>{setBlockNumber(xindex, yIndex);}}>Block</button>
                    <button onClick={()=>{testModelAvailability(xindex, yIndex);}}>Test</button>
                </div>
            );
        }
        else{
            return(
                <div className="gridBoxColor2">
                    <ul>
                        <li>x index = {xindex} </li>
                        <li>y index = {yIndex} </li>
                        <li>lotNumber = { entrymatrix[xindex][yIndex].lotNumber}</li>
                        <li>model = { entrymatrix[xindex][yIndex].model}</li>
                        <li>blockNumber = { entrymatrix[xindex][yIndex].blockNumber}</li>
                        <li>elevation = { entrymatrix[xindex][yIndex].elevation}</li>
                    </ul>
                    <input type="text" id={idLotNumber}></input>
                    <input type="text" id={modelNumber}></input>
                    <input type="text" id={blockNumber}></input>
                    <button onClick={()=>{setLotAndModel(xindex, yIndex);}}>Enter</button>
                    <button onClick={()=>{setBlockNumber(xindex, yIndex);}}>Block</button>
                </div>
            );
        }
    }

    const setLotAndModel = (xindex, yIndex) =>{
        var idLotNumber = "lotNumberx" + xindex + "y" + yIndex;
        var modelNumber = "modelNumberx" + xindex + "y" + yIndex;

        var newModel = document.getElementById(modelNumber).value;
        var newLot = document.getElementById(idLotNumber).value;

        setLotNumber(xindex,yIndex, newLot);
        //setModel(xindex,yIndex, newModel);

    }

    const setBlockNumber = (xindex, yIndex) =>{
        var blockNumber = "blockNumber" + xindex + "y" + yIndex;

        console.log("Block number " + blockNumber);
        var newBlock = document.getElementById(blockNumber).value;

        setBlock(xindex,yIndex, newBlock);
    }

    const testModelAvailability = (xindex, yIndex) =>{

        var thisLotNumber = entireMatrix[xindex][yIndex]["lotNumber"];

        testAvailability(thisLotNumber);
    }

	return (
        <TransformWrapper
        initialScale={0.5}
      >
        <TransformComponent>
        <div className="matrixHolder">
            <div className="matrixDiv">
            <Grid container spacing={0}>
                {
                    xMatrix.map((index)=>(
                            <div className="matrixColumn">{thisYMatrix(entireMatrix, index)}</div>
                        )
                    )
                }
            </Grid>
            </div>
        </div>
        </TransformComponent>
    </TransformWrapper>);
};

const mapStateToProps = (state) => ({
    userType: state.signIn.userType
})

export default connect(mapStateToProps)(LotMatrix);